import { Domains } from '@ui/hooks/useDomain.hook';
import {
  BHS_PRIMARY_700,
  BSH_LIGHT_700,
  COLOR_BASE_100,
  COLOR_BASE_400,
  COLOR_BASE_600,
  COLOR_BASE_800,
  COLOR_ERROR,
  COLOR_PRIMARY_100,
  COLOR_PRIMARY_200,
  COLOR_PRIMARY_600,
  COLOR_PRIMARY_900,
  COLOR_SECONDARY_600,
  PCE_PRIMARY,
  PCE_SECONDARY,
  PCE_SECONDARY_TRANSPARENT,
  YWC_PRIMARY_500_TRANSPARENT,
  YWC_PRIMARY_700,
  COLOR_BASE_500,
  COLOR_PRIMARY_300,
  COLOR_BASE_200,
  COLOR_BASE_300,
  PEC_PRIMARY,
  PEC_PRIMARY_TRANSPARENT,
  PEC_SECONDARY,
  PEC_SECONDARY_TRANSPARENT,
  PEC_ERROR,
} from './style.constant';

const PrimaryChatButton = {
  colorPrimary: COLOR_BASE_500, // bg color
  colorPrimaryHover: COLOR_BASE_600,
  primaryShadow: 'none',
  primaryColor: COLOR_BASE_100, // text color

  // TODO add after ui kit is ready
  // disabled state
  // colorTextDisabled: COLOR_BASE_600,
  // colorBgContainerDisabled: 'pink',
};

const SecondaryChatButton = {
  defaultBg: 'transparent',
  colorText: COLOR_BASE_600,
  defaultBorderColor: COLOR_BASE_400,
};

const baseAlert = {
  colorInfoBg: COLOR_BASE_200,
  colorWarningBg: '#0051CA15',
  colorInfoBorder: COLOR_BASE_300,
  colorInfo: COLOR_PRIMARY_600,
};

export const themes = {
  [Domains.YWC]: {
    bgColor: YWC_PRIMARY_700,
    bgColorLight: YWC_PRIMARY_500_TRANSPARENT,
    bgColorSecondaryLight: YWC_PRIMARY_500_TRANSPARENT,
    bgColorSecondary: YWC_PRIMARY_700,
    textColor: YWC_PRIMARY_700,
    textColorDark: YWC_PRIMARY_700,

    base: {
      Select: {
        colorText: YWC_PRIMARY_700,
        colorTextQuaternary: YWC_PRIMARY_700,
      },
      Button: {
        colorPrimary: YWC_PRIMARY_700,
        colorPrimaryHover: YWC_PRIMARY_700,
        colorPrimaryActive: YWC_PRIMARY_700,
        colorLinkHover: YWC_PRIMARY_700,
        colorLink: YWC_PRIMARY_700,
        marginXS: 4,
      },
      Progress: {
        colorInfo: YWC_PRIMARY_700,
        colorError: COLOR_ERROR,
        colorSuccess: YWC_PRIMARY_700,
        circleTextColor: YWC_PRIMARY_700,
        remainingColor: COLOR_BASE_100,
        circleTextFontSize: '48px',
      },
      Alert: baseAlert,
    },
    inverted: {
      Select: {
        colorText: YWC_PRIMARY_700,
        colorTextQuaternary: COLOR_BASE_100,
      },
    },
    chat: {
      PrimaryButton: PrimaryChatButton,
      SecondaryButton: SecondaryChatButton,
    },
  },
  [Domains.CUREWIKI]: {
    bgColor: COLOR_PRIMARY_600,
    bgColorLight: COLOR_PRIMARY_100,
    bgColorLightHover: COLOR_PRIMARY_200,
    bgColorSecondaryLight: COLOR_PRIMARY_200,
    bgColorSecondary: COLOR_SECONDARY_600,
    textColor: COLOR_PRIMARY_600,
    textColorDark: COLOR_PRIMARY_600,

    base: {
      Select: {
        colorText: COLOR_PRIMARY_600,
        colorTextQuaternary: COLOR_PRIMARY_600,
      },
      Button: {
        colorPrimary: COLOR_PRIMARY_600,
        colorPrimaryHover: COLOR_SECONDARY_600,
        defaultHoverColor: COLOR_SECONDARY_600,
        colorLinkHover: COLOR_SECONDARY_600,
        colorLink: COLOR_PRIMARY_600,
        colorPrimaryActive: COLOR_PRIMARY_900,
        marginXS: 4,
        primaryShadow: 'none',
      },
      Progress: {
        colorInfo: COLOR_PRIMARY_600,
        colorError: COLOR_ERROR,
        colorSuccess: COLOR_PRIMARY_600,
        circleTextColor: COLOR_PRIMARY_600,
        remainingColor: COLOR_BASE_100,
        circleTextFontSize: '48px',
      },
      Alert: {
        colorInfoBg: '#0051CA15',
        colorWarningBg: '#0051CA15',
        colorInfoBorder: COLOR_PRIMARY_300,
        colorInfo: COLOR_PRIMARY_600,
      },
    },
    inverted: {
      Select: {
        colorText: COLOR_PRIMARY_600,
        colorTextQuaternary: COLOR_BASE_100,
      },
    },
    chat: {
      PrimaryButton: {
        colorPrimary: COLOR_PRIMARY_600,
        colorPrimaryHover: COLOR_SECONDARY_600, // TODO
        primaryShadow: 'none',
        // primaryColor: '#4BE4A4',
      },
      SecondaryButton: {
        defaultBg: 'transparent',
        defaultBorderColor: COLOR_PRIMARY_600,
        colorText: COLOR_PRIMARY_600,
      },
    },
  },
  [Domains.BHS]: {
    bgColor: BHS_PRIMARY_700,
    bgColorLight: BSH_LIGHT_700,
    bgColorSecondaryLight: BSH_LIGHT_700,
    bgColorSecondary: BHS_PRIMARY_700,
    textColor: BHS_PRIMARY_700,
    textColorDark: COLOR_BASE_800,

    base: {
      Select: {
        colorText: BHS_PRIMARY_700,
        colorTextQuaternary: BHS_PRIMARY_700,
      },
      Button: {
        colorPrimary: BHS_PRIMARY_700,
        colorPrimaryHover: BHS_PRIMARY_700,
        colorPrimaryActive: BHS_PRIMARY_700,
        colorLink: BHS_PRIMARY_700,
        marginXS: 4,
      },
      Progress: {
        colorInfo: BHS_PRIMARY_700,
        colorError: COLOR_ERROR,
        colorSuccess: BHS_PRIMARY_700,
        circleTextColor: BHS_PRIMARY_700,
        remainingColor: COLOR_BASE_100,
        circleTextFontSize: '48px',
      },
      Alert: baseAlert,
    },
    inverted: {
      Select: {
        colorText: BHS_PRIMARY_700,
        colorTextQuaternary: COLOR_BASE_100,
      },
    },
    chat: {
      PrimaryButton: PrimaryChatButton,
      SecondaryButton: SecondaryChatButton,
    },
  },
  [Domains.PCE]: {
    bgColor: PCE_PRIMARY,
    bgColorLight: PCE_SECONDARY_TRANSPARENT,
    bgColorSecondaryLight: PCE_SECONDARY_TRANSPARENT,
    bgColorSecondary: PCE_SECONDARY,
    textColor: PCE_SECONDARY,
    textColorDark: PCE_SECONDARY,

    base: {
      Select: {
        colorText: PCE_PRIMARY,
        colorTextQuaternary: PCE_PRIMARY,
      },
      Button: {
        colorPrimary: PCE_SECONDARY,
        colorPrimaryHover: PCE_PRIMARY,
        colorPrimaryActive: PCE_SECONDARY,
        colorLink: PCE_SECONDARY,
        colorLinkHover: PCE_SECONDARY,
        marginXS: 4,
        primaryShadow: 'none',
      },
      Progress: {
        colorInfo: PCE_PRIMARY,
        colorError: COLOR_ERROR,
        colorSuccess: PCE_SECONDARY,
        circleTextColor: PCE_SECONDARY,
        remainingColor: COLOR_BASE_100,
        circleTextFontSize: '48px',
      },
      Alert: baseAlert,
    },
    inverted: {
      Select: {
        colorText: PCE_PRIMARY,
        colorTextQuaternary: COLOR_BASE_100,
      },
    },
    chat: {
      PrimaryButton: PrimaryChatButton,
      SecondaryButton: SecondaryChatButton,
    },
  },
  [Domains.PEC]: {
    bgColor: PEC_PRIMARY,
    bgColorLight: PEC_PRIMARY_TRANSPARENT,
    bgColorSecondaryLight: PEC_SECONDARY_TRANSPARENT,
    bgColorSecondary: PEC_SECONDARY,
    textColor: PEC_SECONDARY,
    textColorDark: PEC_SECONDARY,

    base: {
      Select: {
        colorText: PEC_PRIMARY,
        colorTextQuaternary: PEC_PRIMARY,
      },
      Button: {
        colorPrimary: PEC_SECONDARY,
        colorPrimaryHover: PEC_PRIMARY,
        colorPrimaryActive: PEC_SECONDARY,
        colorLink: PEC_SECONDARY,
        colorLinkHover: PEC_SECONDARY,
        marginXS: 4,
        primaryShadow: 'none',
      },
      Progress: {
        colorInfo: PEC_PRIMARY,
        colorError: PEC_ERROR,
        colorSuccess: PEC_SECONDARY,
        circleTextColor: PEC_SECONDARY,
        remainingColor: COLOR_BASE_100,
        circleTextFontSize: '48px',
      },
      Alert: baseAlert,
    },
    inverted: {
      Select: {
        colorText: PEC_PRIMARY,
        colorTextQuaternary: COLOR_BASE_100,
      },
    },
    chat: {
      PrimaryButton: {
        ...PrimaryChatButton,
        colorPrimary: PEC_SECONDARY,
        colorPrimaryHover: PEC_PRIMARY,
      },
      SecondaryButton: {
        ...SecondaryChatButton,
        colorText: PEC_PRIMARY,
        defaultBorderColor: PEC_SECONDARY,
      },
    },
    components: {
      Typography: {
        fontFamily: '"Work Sans", sans-serif',
      },
    },
  },
};
